import { Controller } from "@hotwired/stimulus"

// Drag-to-reorder for CMS page blocks (native HTML5 DnD; no external lib).
// On drop, PATCHes the new order to the page's reorder endpoint (Turbo-safe).
export default class extends Controller {
  static targets = ["item"]
  static values = { url: String }

  connect() {
    this.itemTargets.forEach((item) => {
      item.addEventListener("dragstart", () => { this.dragging = item; item.classList.add("dragging") })
      item.addEventListener("dragend", () => { item.classList.remove("dragging"); this.persist() })
    })
    this.element.addEventListener("dragover", (e) => {
      e.preventDefault()
      if (!this.dragging) return
      const after = this.afterElement(e.clientY)
      if (after == null) this.element.appendChild(this.dragging)
      else this.element.insertBefore(this.dragging, after)
    })
  }

  afterElement(y) {
    const els = [...this.element.querySelectorAll("[data-sortable-target='item']:not(.dragging)")]
    return els.reduce((closest, child) => {
      const box = child.getBoundingClientRect()
      const offset = y - box.top - box.height / 2
      if (offset < 0 && offset > closest.offset) return { offset, element: child }
      return closest
    }, { offset: Number.NEGATIVE_INFINITY }).element
  }

  persist() {
    const order = this.itemTargets.map((i) => i.dataset.id)
    const token = document.querySelector("meta[name=csrf-token]")?.content
    fetch(this.urlValue, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", "X-CSRF-Token": token },
      body: JSON.stringify({ order }),
    })
  }
}
